import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { FieldItem } from "./FieldItem";
import * as styles from "./styles_vanilla.css";
import type { Section } from "../../../CustomFields/types";
import type { EntityExtensionFieldValue } from "../../types";

export type SectionViewProps = {
  section: Section;
  fields: EntityExtensionFieldValue[];
  onFieldChange: (fieldId: string, value: string) => void;
};

export const SectionView: React.FC<SectionViewProps> = ({ section, fields, onFieldChange }) => (
  <Flex flexDirection="column" key={section.id} className={styles.sectionContainer}>
    <Flex flexDirection="column" gap={SPACING.SMALL} className={styles.sectionHeader}>
      <Text variant="regular-lg" className={styles.sectionTitleInTab}>
        {section.name}
      </Text>
      {section.description && <Text variant="regular-sm">{section.description}</Text>}
    </Flex>
    <Flex
      flexDirection="row"
      gap={SPACING.MEDIUM}
      flexWrap="wrap"
      className={styles.sectionFields}
    >
      {fields.map((fieldValue) => (
        <FieldItem
          key={fieldValue.field?.id}
          fieldValue={fieldValue}
          onFieldChange={onFieldChange}
        />
      ))}
    </Flex>
  </Flex>
);
